<app-toolbar></app-toolbar>
<!-- <div class="body-estruct"> -->
<div class="body-estruct">
    <div class="container pt-50x">
        <div class="row justify-content-md-center">
            <div class="col-12 col-sm-12 col-md-10 col-lg-6 col-xl-6 text-center py-20x">
                <h1 class="title">Datos del Auto</h1>
            </div>
        </div>
        <div class="row justify-content-md-center">
            <div class="col-12 col-sm-12 col-md-10 col-lg-6 col-xl-6 text-center py-20x">
                <p class="sub-title">
                    ¡Vamos a proteger tu automóvil! Por favor, <br />
                    ingresa los datos de tu vehículo.
                </p>
            </div>
        </div>
        <div class="row justify-content-md-center">
            <div class="col-12 col-sm-12 col-md-10 col-lg-6 col-xl-6 text-center py-20x">
                <select placeholder="Modelo" [(ngModel)]="datosCotizacion.multicotiza.f4" class="m-auto">
                    <option value="null">Modelo</option>
                    <option value="2020">2020</option>
                    <option value="2019">2019</option>
                    <option value="2018">2018</option>
                    <option value="2017">2017</option>
                    <option value="2016">2016</option>
                    <option value="2015">2015</option>
                    <option value="2014">2014</option>
                    <option value="2013">2013</option>
                    <option value="2012">2012</option>
                    <option value="2011">2011</option>
                    <option value="2010">2010</option>
                    <option value="2009">2009</option>
                    <option value="2008">2008</option>
                    <option value="2007">2007</option>
                    <option value="2006">2006</option>
                    <option value="2005">2005</option>
                    <option value="2004">2004</option>
                    <option value="2003">2003</option>
                    <option value="2002">2002</option>
                    <option value="2001">2001</option>
                    <option value="2000">2000</option>
                </select>
            </div>
        </div>
        <div class="row justify-content-md-center">
            <div class="col-12 col-sm-12 col-md-10 col-lg-6 col-xl-6 text-center py-20x">
                <autos-busqueda [wkstId]="0" [aseguradoraId]="aseguradoraId"
                    [modeloAuto]="datosCotizacion.multicotiza.f4" [pickup]="this.datosCotizacion.multicotiza.f7"
                    [amis]="this.datosCotizacion.multicotiza.f3" [negocioId]="this.datosCotizacion.multicotiza.f1"
                    [tipoVehiculoBuscador]="tipoVehiculoBuscador" searchCpAPI="" (dataSalida)="reiniciaAmis($event)"
                    (dataAutoSalida)="autosSalida($event)" *ngIf="aseguradoraId>0">
                </autos-busqueda>
            </div>
        </div>
        <div class="row justify-content-md-center">
            <div class="col-12 col-sm-12 col-md-10 col-lg-6 col-xl-6 text-center py-20x">
                <h2 class="title">¿Qué te preocupa?</h2>
            </div>
        </div>
        <div class="row justify-content-md-center">
            <div class="col-12 col-sm-12 col-md-10 col-lg-6 col-xl-6 text-center py-20x">
                <div class="table-sio w-100">
                    <div class="cell-sio w-50">
                        <button mat-flat-button class="w-100 border-radius-right mh-50x border-botton"
                            [ngClass]="{'background-white' : tipo!==1, 'background-marino':tipo===1}"
                            (click)="tipoPaquete(1)">Protección</button>
                    </div>
                    <div class="cell-sio w-50">
                        <button mat-flat-button class="w-100 border-radius-left mh-50x border-botton"
                            [ngClass]="{'background-white' : tipo!==2, 'background-marino' : tipo===2}"
                            (click)="tipoPaquete(2)">Precio</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row justify-content-md-center" *ngIf="tipo > 0">
            <div class="col-12 text-center py-20x">
                <p>
                    No tienes que saber todos los términos de seguros, para eso nos tienes a nosotros, lo que si tienes
                    que saber<br>
                    es que cobertura se adapta a lo que necesitas, por eso existe esto en todos los lugares de búsqueda:
                </p>
                <button mat-flat-button class="btn-llamada" [color]="styleCocheSeguro?.colorBtn" (click)="obtenerAyuda()">
                    <mat-icon>phone</mat-icon> Ayuda
                </button>
            </div>
        </div>
        <div class="row" *ngIf="tipo > 0">
            <div class="col-12">
                <!-- <div class="row m-0x justify-content-md-center"> -->
                <mat-radio-group class="row m-0x justify-content-md-center"
                    [(ngModel)]="datosCotizacion.datosAuto.paquete">
                    <div class="col-xl-4 col-md-6 col-sm-12 pb-20x maxw-350x display-inline-block">
                        <div class="paquete-body pt-30x radius border-top"
                            [ngClass]="datosCotizacion.datosAuto.paquete == 0 ? 'active' : ''">
                            <div class="table-sio w-100">
                                <div class="row-sio">
                                    <div class="cell-sio text-center">
                                        <h2 class="title area-paquete">AMPLIA</h2>
                                        <hr />
                                    </div>
                                </div>
                                <div class="row-sio">
                                    <div class="cell-sio text-left pt-10x  px-30x">
                                        <h5 class="title gray">Coberturas incluidas</h5>
                                    </div>
                                </div>
                                <div class="row-sio text-left">
                                    <div class="cell-sio pl-20x py-10x">
                                        <div class="table-sio">
                                            <div class="cell-sio text-middle">
                                                <mat-icon
                                                    class="display-inline-block verde-claro vertical-middle fs-18">check
                                                </mat-icon>
                                            </div>
                                            <div class="cell-sio text-middle">
                                                <p class="text-left display-inline-block m-0">Defensa Jurídica</p>
                                            </div>
                                            <div class="cell-sio text-middle">
                                                <mat-icon
                                                    class="display-inline-block vertical-middle pl-5x fs-18 cursor-pointer gray">
                                                    error_outline</mat-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row-sio text-left">
                                    <div class="cell-sio pl-20x py-10x">
                                        <div class="table-sio">
                                            <div class="cell-sio text-middle">
                                                <mat-icon
                                                    class="display-inline-block verde-claro vertical-middle fs-18">check
                                                </mat-icon>
                                            </div>
                                            <div class="cell-sio text-middle">
                                                <p class="text-left display-inline-block m-0">Asistencias</p>
                                            </div>
                                            <div class="cell-sio text-middle">
                                                <mat-icon
                                                    class="display-inline-block vertical-middle pl-5x fs-18 cursor-pointer gray">
                                                    error_outline</mat-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row-sio text-left">
                                    <div class="cell-sio px-20x py-10x">
                                        <p class="text-left display-inline-block">
                                            Cubre <b>Daños Materiales</b> a tu auto (parcial o total);
                                            <b>robo total, responsabilidad civíl</b>
                                            si ocasionas daños a un tercero derivado de algún accidente.
                                        </p>
                                    </div>
                                </div>
                                <div class="row-sio">
                                    <div class="cell-sio text-center pb-20x">
                                        <mat-radio-button [value]="0"></mat-radio-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-md-6 col-sm-12 pb-20x maxw-350x display-inline-block">
                        <div class="paquete-body pt-30x radius border-top"
                            [ngClass]="datosCotizacion.datosAuto.paquete == 1 ? 'active' : ''">
                            <div class="table-sio w-100">
                                <div class="row-sio">
                                    <div class="cell-sio text-center">
                                        <h2 class="title area-paquete">LIMITADA</h2>
                                        <hr />
                                    </div>
                                </div>
                                <div class="row-sio">
                                    <div class="cell-sio text-left pt-10x  px-30x">
                                        <h5 class="title gray">Coberturas incluidas</h5>
                                    </div>
                                </div>
                                <div class="row-sio text-left">
                                    <div class="cell-sio pl-20x py-10x">
                                        <div class="table-sio">
                                            <div class="cell-sio text-middle">
                                                <mat-icon
                                                    class="display-inline-block verde-claro vertical-middle fs-18">check
                                                </mat-icon>
                                            </div>
                                            <div class="cell-sio text-middle">
                                                <p class="text-left display-inline-block m-0">Defensa Jurídica</p>
                                            </div>
                                            <div class="cell-sio text-middle">
                                                <mat-icon
                                                    class="display-inline-block vertical-middle pl-5x fs-18 cursor-pointer gray">
                                                    error_outline</mat-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row-sio text-left">
                                    <div class="cell-sio pl-20x py-10x">
                                        <div class="table-sio">
                                            <div class="cell-sio text-middle">
                                                <mat-icon
                                                    class="display-inline-block verde-claro vertical-middle fs-18">check
                                                </mat-icon>
                                            </div>
                                            <div class="cell-sio text-middle">
                                                <p class="text-left display-inline-block m-0">Asistencias</p>
                                            </div>
                                            <div class="cell-sio text-middle">
                                                <mat-icon
                                                    class="display-inline-block vertical-middle pl-5x fs-18 cursor-pointer gray">
                                                    error_outline</mat-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row-sio text-left">
                                    <div class="cell-sio px-20x py-10x">
                                        <p class="text-left display-inline-block">
                                            Cubre
                                            <b>robo total, responsabilidad civíl</b>
                                            si ocasionas daños a un tercero derivado de algún accidente.
                                        </p>
                                    </div>
                                </div>
                                <div class="row-sio">
                                    <div class="cell-sio text-center pb-20x">
                                        <mat-radio-button [value]="1"></mat-radio-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-4 col-md-6 col-sm-12 pb-20x maxw-350x display-inline-block">
                        <div class="paquete-body pt-30x radius border-top"
                            [ngClass]="datosCotizacion.datosAuto.paquete == 2 ? 'active' : ''">
                            <div class="table-sio w-100">
                                <div class="row-sio">
                                    <div class="cell-sio text-center">
                                        <h2 class="title area-paquete">BÁSICA</h2>
                                        <hr />
                                    </div>
                                </div>
                                <div class="row-sio">
                                    <div class="cell-sio text-left pt-10x  px-30x">
                                        <h5 class="title gray">Coberturas incluidas</h5>
                                    </div>
                                </div>
                                <div class="row-sio text-left">
                                    <div class="cell-sio pl-20x py-10x">
                                        <div class="table-sio">
                                            <div class="cell-sio text-middle">
                                                <mat-icon
                                                    class="display-inline-block verde-claro vertical-middle fs-18">check
                                                </mat-icon>
                                            </div>
                                            <div class="cell-sio text-middle">
                                                <p class="text-left display-inline-block m-0">Defensa Jurídica</p>
                                            </div>
                                            <div class="cell-sio text-middle">
                                                <mat-icon
                                                    class="display-inline-block vertical-middle pl-5x fs-18 cursor-pointer gray">
                                                    error_outline</mat-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row-sio text-left">
                                    <div class="cell-sio pl-20x py-10x">
                                        <div class="table-sio">
                                            <div class="cell-sio text-middle">
                                                <mat-icon
                                                    class="display-inline-block verde-claro vertical-middle fs-18">check
                                                </mat-icon>
                                            </div>
                                            <div class="cell-sio text-middle">
                                                <p class="text-left display-inline-block m-0">Asistencias</p>
                                            </div>
                                            <div class="cell-sio text-middle">
                                                <mat-icon
                                                    class="display-inline-block vertical-middle pl-5x fs-18 cursor-pointer gray">
                                                    error_outline</mat-icon>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row-sio text-left">
                                    <div class="cell-sio px-20x py-10x">
                                        <h5 class="title gray">Usas autopista en alguń momento, ¡aguas! Los oficiales te
                                            van a
                                            exigir esta
                                            cobertura:</h5>
                                    </div>
                                </div>
                                <div class="row-sio text-left">
                                    <div class="cell-sio px-20x py-10x">
                                        <p class="text-left display-inline-block">
                                            <b>Responsabilidad civíl</b>
                                            si ocasionas daños a un tercero derivado de algún accidente.
                                        </p>
                                    </div>
                                </div>
                                <div class="row-sio">
                                    <div class="cell-sio text-center pb-20x">
                                        <mat-radio-button [value]="2"></mat-radio-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-radio-group>
                <!-- </div> -->
            </div>
            <div class="col-12 text-center py-20x" *ngIf="1 == 1">
                <button mat-stroked-button [color]="styleCocheSeguro?.colorBtn" class="align-middle" (click)="next()">
                    <label class="ml-2 align-middle cursor-pointer"><strong>QUIERO CONTRATAR</strong></label>
                </button>
            </div>
            <br />
        </div>
    </div>
</div>
<!-- </div> -->
<app-footer></app-footer>